import { Controller } from "@hotwired/stimulus"

// Slot picker for the doctor profile "Request Appointment" sidebar.
// Supports multiple practice locations: switching the location select shows that
// hospital's group (info + slots). "Book" fills the appointment modal's hidden
// consult fields + hospital + slot banner, then opens #appointmentModal.
export default class extends Controller {
  static targets = ["hospitalGroup", "day", "panel", "slot", "bookBtn", "summary"]
  static values = { doctorId: String }

  connect() {
    this.selected = null
    const group = this.activeGroup()
    if (group) this.initGroup(group)
  }

  activeGroup() {
    return this.hospitalGroupTargets.find((g) => !g.classList.contains("hidden")) ||
           this.hospitalGroupTargets[0] || this.element
  }

  initGroup(group) {
    const firstDay = group.querySelector('[data-doctor-slots-target="day"]')
    if (firstDay) this.activateDay(group, firstDay.dataset.date)
  }

  changeHospital(event) {
    // Reload the profile with ?hospital=slug so the whole page (hero, FAQ, related
    // specialists, dropdown) re-renders for the selected hospital. Fall back to the
    // client-only group switch if the option has no slug.
    const opt = event.target.selectedOptions[0]
    const slug = opt && opt.dataset.slug
    if (slug) {
      const url = new URL(window.location.href)
      url.searchParams.set("hospital", slug)
      window.location.href = url.pathname + url.search
      return
    }

    const id = event.target.value
    this.hospitalGroupTargets.forEach((g) => g.classList.toggle("hidden", g.dataset.hospitalId !== id))
    this.resetSelection()
    const group = this.activeGroup()
    if (group) this.initGroup(group)
  }

  selectDay(event) {
    const group = this.groupOf(event.currentTarget)
    this.activateDay(group, event.currentTarget.dataset.date)
  }

  activateDay(group, date) {
    group.querySelectorAll('[data-doctor-slots-target="day"]').forEach((d) => { d.dataset.active = String(d.dataset.date === date) })
    group.querySelectorAll('[data-doctor-slots-target="panel"]').forEach((p) => p.classList.toggle("hidden", p.dataset.date !== date))
  }

  selectSlot(event) {
    event.preventDefault()
    event.stopPropagation()

    const btn = event.currentTarget
    const group = this.groupOf(btn)
    
    const selected = {
      date: btn.dataset.date,
      time: btn.dataset.time,
      display: btn.dataset.display,
      dateLabel: btn.dataset.dateLabel,
      hospital: group.dataset.hospitalId
    }

    const set = (id, val) => { const el = document.getElementById(id); if (el) el.value = val }
    set("popup_consult_date", selected.date)
    set("popup_consult_time", selected.time)

    if (selected.hospital) {
      const sel = document.getElementById("hospital_select")
      if (sel) { sel.value = selected.hospital; sel.dispatchEvent(new Event("change", { bubbles: true })) }
    }

    const text = document.getElementById("popup_selected_slot_text")
    if (text) text.textContent = `${selected.dateLabel} at ${selected.display}`
    const banner = document.getElementById("popup_selected_slot_banner")
    if (banner) banner.classList.remove("hidden")

    const modalEl = document.getElementById("appointmentModal")
    if (modalEl) {
      modalEl.dataset.hospitalId = selected.hospital
      modalEl.dataset.doctorId = this.doctorIdValue

      const modal = (window.Modal || (window.bootstrap && window.bootstrap.Modal)).getOrCreateInstance(modalEl)
      modal.show()
    }
  }

  resetSelection() {
    this.selected = null
    this.slotTargets.forEach((s) => { s.dataset.selected = "false" })
  }

  groupOf(el) {
    return el.closest('[data-doctor-slots-target="hospitalGroup"]') || this.element
  }
}
